import React from "react";
import "../css/about.scss";
import { Link } from "react-router-dom";
import { STORE_CONFIG } from "../config/store";

function About() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div className="about-page">
      <div className="breadcrumb"><Link to="/" onClick={toTop}>Home</Link> &gt; <span>About</span></div>
      <div className="about-banner"><img src="/img/editorial/about-01.png" alt="An organised online gift studio and packing table" /></div>
      <div className="about-intro">
        <h2>Colourful objects, chosen for real life</h2>
        <p>{STORE_CONFIG.brand} is an online gift shop operated from {STORE_CONFIG.operatingRegion}, bringing together original cards, characterful mugs, soft pieces and useful home textiles.</p>
      </div>
      <div className="about-split">
        <div className="split-image"><img src="/img/editorial/about-02.png" alt="Original cards being selected on a studio table" /></div>
        <div className="split-content">
          <h3>Made to feel personal</h3>
          <p>We favour clear materials, specific care guidance and designs with a point of view. Each card and gift should be easy to understand before it reaches your basket.</p>
          <p>Our catalogue mixes sincere colour with grown-up humour, while keeping every illustration and product image original.</p>
          <Link className="purple-btn" to="/shop" onClick={toTop}>Browse the collection</Link>
        </div>
      </div>
      <div className="about-split reverse">
        <div className="split-content">
          <h3>Packed with practical care</h3>
          <p>Orders are prepared for delivery with product-appropriate protection. Where an item is fragile, magnetic, heat-related or intended only for supervised use, that guidance appears on its product page.</p>
          <p>Questions are welcome before or after ordering.</p>
          <a className="purple-btn" href={`mailto:${STORE_CONFIG.supportEmail}`}>Email us</a>
        </div>
        <div className="split-image"><img src="/img/editorial/about-03.png" alt="Gift items being packed in recyclable paper" /></div>
      </div>
    </div>
  );
}

export default About;
